export { default } from './BlankLink';
